import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ServicesPage from './pages/services';
import Portfolio from "pages/portfolio";
import Homepage from "pages/homepage";
import Contact from "pages/contact";
import BlogPage from "pages/blog";
import About from "pages/about";
// import { SpeedInsights } from "@vercel/speed-insights/next"
import { SpeedInsights } from "@vercel/speed-insights/react";



const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<Homepage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
        
      </RouterRoutes>

      <SpeedInsights/>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
